import React from 'react';

const footerLinkStyle = {
  color: '#fff',
  textDecoration: 'none',
  fontWeight: 500,
  fontSize: 'inherit',
  margin: '0 2px',
  transition: 'color 0.2s',
};

const Footer = () => (
  <footer className="footer-zazi" style={{
    width: '100%',
    padding: '4px 0 2px 0',
    background: 'linear-gradient(135deg, rgba(15,32,39,0.90) 0%, rgba(44,83,100,0.82) 40%, rgba(67,206,162,0.68) 100%)',
    color: '#fff',
    fontWeight: 400,
    fontSize: 'calc(12px + 0.3vw)',
    letterSpacing: 0.5,
    boxShadow: '0 -2px 8px #203a4330',
    position: 'fixed',
    left: 0,
    bottom: 0,
    zIndex: 1000,
    minHeight: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2
  }}>
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      gap: 0,
      fontSize: 'inherit',
      width: '100%',
      justifyContent: 'center',
    }}>
      <a href="/about" style={footerLinkStyle}>About</a>
      <span style={{opacity: 0.6, margin: '0 2px'}}>|</span>
      <a href="/contact" style={footerLinkStyle}>Contact</a>
      <span style={{opacity: 0.6, margin: '0 2px'}}>|</span>
      <a href="/privacy" style={footerLinkStyle}>Privacy Policy</a>
      <span style={{opacity: 0.6, margin: '0 2px'}}>|</span>
      <a href="/terms" style={footerLinkStyle}>Terms</a>
      <span style={{opacity: 0.7, margin: '0 8px'}}>|</span>
      <span style={{fontWeight:600,letterSpacing:1}}>Zazi</span> &copy; {new Date().getFullYear()} Zazi App. All rights reserved.
    </span>
  </footer>
);

export default Footer;
